import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import { ASSETS, SITE } from "@/constants/site";
import NewsletterForm from "./NewsletterForm";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-deepforest text-cream">
      <div className="mx-auto max-w-7xl px-6 py-16 md:px-10 md:py-20">
        <div className="grid gap-12 md:grid-cols-2 md:gap-8">
          <div>
            <img src={ASSETS.wordmarkCream} alt="sita" className="h-12 w-auto" data-testid="footer-wordmark" />
            <p className="mt-4 font-display text-lg italic text-gold">{SITE.tagline}</p>
            <div className="mt-6">
              <a
                href={SITE.instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram-link"
                aria-label="Sita on Instagram"
                className="inline-flex text-cream/80 transition-colors hover:text-gold"
              >
                <Instagram size={20} strokeWidth={1.75} />
              </a>
            </div>
          </div>
          <div>
            <p className="text-xs font-medium uppercase tracking-[0.22em] text-cream/60">Stay at the table</p>
            <p className="mt-3 max-w-sm text-sm leading-relaxed text-cream/80">
              Join the Sita email list for upcoming supper club dates, menu previews, and first access to tickets.
            </p>
            <div className="mt-5">
              <NewsletterForm variant="dark" testidPrefix="footer" />
            </div>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-6 border-t border-cream/15 pt-8 md:flex-row md:items-center md:justify-between">
          <nav className="flex flex-wrap gap-x-6 gap-y-2 text-sm text-cream/70">
            <Link to="/supper-club" className="link-underline hover:text-gold" data-testid="footer-link-supper-club">Supper Club</Link>
            <Link to="/catering" className="link-underline hover:text-gold" data-testid="footer-link-catering">Catering</Link>
            <Link to="/meal-prep" className="link-underline hover:text-gold" data-testid="footer-link-meal-prep">Meal Prep</Link>
            <Link to="/private-events" className="link-underline hover:text-gold" data-testid="footer-link-private-events">Private Events & Chef Services</Link>
            <Link to="/about" className="link-underline hover:text-gold" data-testid="footer-link-about">About</Link>
            <Link to="/inquiries" className="link-underline hover:text-gold" data-testid="footer-link-inquiries">Inquiries</Link>
            <Link to="/feedback" className="link-underline hover:text-gold" data-testid="footer-link-feedback">Leave a review</Link>
          </nav>
          <p className="text-xs tracking-wide text-cream/50">© {new Date().getFullYear()} Sita. All rights reserved.</p>
        </div>

        <p className="mt-8 text-xs tracking-wide text-cream/40">{SITE.locationLine}</p>
      </div>
    </footer>
  );
}
